function Signup() {
    return ( 
    <div>
        <h1>Signup</h1>
    </div> 
    );
}

export default Signup;